import { POST_LOGOUT_WATCHER, POST_LOGOUT_SUCCESS, POST_LOGOUT_FAILED } from './constants';

const initialState = {
	isLoadingLogout: true,
	data: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case POST_LOGOUT_WATCHER:
			return {
				isLoadingLogout: true,
				data: {}
			};
		case POST_LOGOUT_SUCCESS:
			return {
				isLoadingLogout: false,
				data: action.payload
			};

		case POST_LOGOUT_FAILED:
			return {
				isLoadingLogout: false,
				data: {}
			};

		default:
			return state;
	}
};
